export default __webpack_public_path__ + "static/media/Girdle of the Dark Messenger.2ca8d6ae.jpg";